import { useFormContext } from 'react-hook-form';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ShuffleIcon } from '@/icons';
import { useAvatarCatalog } from '@/shared/features/user-avatar';
import { Button, IconButton } from '@/ui_v3';
import { getAccessorySlots, pickRandomAccessoryPartId, pickRandomPartId, setAccessoryId } from '../avatarDecorate.logic';
import { type AvatarDecorateForm } from '../schema';
export const RandomAvatarButton = ({
  iconOnly = false
}: {
  iconOnly?: boolean;
}) => {
  const {
    setValue,
    getValues
  } = useFormContext<AvatarDecorateForm>();
  const {
    t
  } = useTranslation('common');
  const {
    data: catalog
  } = useAvatarCatalog('quiz');
  const randomize = () => {
    if (!catalog) return;
    const current = getValues('avatar');
    // 액세서리도 같이 굴린다. 이전에는 필수 슬롯 4개만 바꾸고 accessoryIds 를 그대로
    // 넘겨서, 안경을 사도 랜덤 결과에 영영 안 나왔다.
    const accessoryIds = getAccessorySlots().reduce((ids, {
      slot,
      shapeKey
    }) => setAccessoryId(ids, slot, pickRandomAccessoryPartId(catalog.shapes[shapeKey] ?? [])), current.accessoryIds);
    setValue('avatar', {
      ...current,
      skinId: pickRandomPartId(catalog.shapes.skin ?? []),
      hairId: pickRandomPartId(catalog.shapes.hair ?? []),
      faceId: pickRandomPartId(catalog.shapes.face ?? []),
      clothesId: pickRandomPartId(catalog.shapes.clothes ?? []),
      accessoryIds
    }, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true
    });
  };
  return iconOnly ? <IconButton variant="outlined" intent="neutral" size="md" rounded="default" aria-label={t('avatarDecorate.random')} onClick={randomize} data-sentry-element="IconButton" data-sentry-component="RandomAvatarButton" data-sentry-source-file="RandomAvatarButton.tsx">
      <ShuffleIcon size="sm" color={ICON_COLOR.neutral} data-sentry-element="ShuffleIcon" data-sentry-source-file="RandomAvatarButton.tsx" />
    </IconButton> : <Button type="button" variant="outlined" intent="neutral" size="md"
  // Figma 1410:19573 — effect 없음(그림자 X), 배경 bg/default.
  className="bg-default shadow-none" leftSlot={<ShuffleIcon size="xs" color={ICON_COLOR.neutral} />} onClick={randomize} data-sentry-element="Button" data-sentry-component="RandomAvatarButton" data-sentry-source-file="RandomAvatarButton.tsx">
      {t('avatarDecorate.random')}
    </Button>;
};